import React, {useContext} from 'react';
import {TableWrapperContext} from './TableWrapper';

const ResultsCount = () => {
  const {resultsCount} = useContext(TableWrapperContext);

  return (
    <>
      {resultsCount > 1 && <span className='text-gray-600'>{resultsCount} результатов</span>}
    </>
  );
};

export default ResultsCount;
